import swal from 'sweetalert2'

/**
 * @todo replace arg pass by importing i18n
 * @param {Function} t - Vue translation function
 * @returns {Promise<boolean>}
 */
export function confirmSkipOverlapCheck(t) {
  const title = t('drivers.new_layout_schedule_overlap_title')
  const text = t('drivers.messages.new_layout_confirm_skip_overlap_check')
  const confirmText = t('general.ok')
  const cancelText = t('general.cancel')

  return swal
    .fire({
      type: 'warning',
      title,
      text,
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
    })
    .then((result) => result.value ?? false)
}

export function isSlotConflict(error) {
  return error.status === 422 && error.data?.error_code === 'slot_conflict'
}
